import React, { Component } from 'react';

// Material components/
import { Paper, Typography } from '@mui/material';

// Form Validation and Dynamic Forms
import { DynamicForm } from 'components/Forms';

import NavigateBack from 'components/NavigateBack';

import speciesFields from './species.fields';

import { createNewSpecies } from 'services/species-details';

export default class AddNewSupplier extends Component {
  constructor(props) {
    super(props);
    speciesFields[2].callback = this.calculateCubicleFee;
    speciesFields[3].callback = this.calculateCubicleFee
  }
  
  calculateCubicleFee = async (name, value, formData, asyncCb) => {
    let labFee = formData.lab_fee ? parseInt(formData.lab_fee) : 0;
    let quarantineFee = formData.quarantine_fee ? parseInt(formData.quarantine_fee) : 0;
    
    formData.cubicle_fee = labFee + quarantineFee;
    
    return { fields : null, values : formData};
  }

  // Form is handled by dynamic forms, always return data as
  // JSON : { status : "success"/"error", message : ".....", data: {optional errors} }
  //
  handleFormSubmit = async (params) => {
    let statusMessage = { status: "success", message: "Successfully added new species..." };
    
    // todo API calls
    try {
      let response = await createNewSpecies(params);
    } catch (error) {
      console.log(error);
      statusMessage = { status : "error", message : error.message, data : error.data};
    }
    
    return statusMessage;
  }

  render() {
    return (
      <>
        <NavigateBack />
        <Paper elevation={3} sx={{textAlign:"center", m:2, p:2}}>
          <Typography variant="h4"> Add New Species </Typography> <br/><hr style={{borderColor:"#eef1f6"}} />
          <DynamicForm
            formFields={speciesFields}
            action="create"
            handleSubmit={this.handleFormSubmit}
            buttonText="Save Supplier Details"
            buttonWidth= "full"
            columns = {3}
            redirect={'/aqf/admin/species-details/list'}
            confirmation={"Are you sure you want to save the details ? "}
          />
        </Paper>
      </>
    );
  }
}